import React from "react";
import "./progress-bar.scss";

export interface ProgressBarProps {
  /** Width of the progress bar */
  width?: string;
  /** Height of the progress bar */
  height?: string;
  /** Progress percentage (0-100) */
  progress: number;
  /** Additional CSS class name */
  className?: string;
  /** Whether to show the shimmer animation */
  showShimmer?: boolean;
}

/**
 * ProgressBar - A gradient progress bar with optional shimmer effect
 * 
 * Features:
 * - Gradient background with financial theme colors
 * - Smooth transitions
 * - Optional shimmer animation
 * - Customizable dimensions
 */
export const ProgressBar: React.FC<ProgressBarProps> = ({ 
  width = "200px", 
  height = "6px", 
  progress,
  className = "",
  showShimmer = true
}) => (
  <div 
    className={`progress-bar-container ${className}`} 
    style={{ width, height }}
  >
    <div 
      className={`progress-bar ${showShimmer ? 'with-shimmer' : ''}`}
      style={{ 
        height,
        width: `${Math.max(0, Math.min(100, progress))}%`
      }}
    />
  </div>
);

export default ProgressBar;
